<template>
    <el-row :gutter="15">
        <el-col :sm="24" :md="24" :lg="24" class="mb-3 mb-lg-10" style="float: right;">
            <div class="mb-3">
                <div v-if="activeName === 'korrupsiyaga_qkurash'">
                  <div>
                    <el-row :gutter="15">
                      <el-col :sm="12" :md="12" :lg="8" class="mb-3" v-for="(item, index) in news">
                        <div class="card card-lift--hover bg-defaultnew shadow border-0">
                          <router-link :to="`/newsview?id=${item.id}`">
                            <img :src="`https://www.prokuratura.uz/api/download/${item.titleImage}`"
                                 class="card-img-top">
                            <span class="press_fastnews_status" v-if="index === 0 || index === 1 || index === 2">{{$t('homepage.korrupsiyaga_qkurash')}}</span>
                            <blockquote class="card-blockquote">
                              <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                                   viewBox="0 0 583 95"
                                   class="svg-bg">
                                <polygon points="0,52 583,95 0,95"
                                         class="fill-defaultnew"></polygon>
                                <polygon points="0,42 583,95 683,0 0,95" opacity=".2"
                                         class="fill-default"></polygon>
                              </svg>
                              <span class="badge badge-primary">{{parseDate(item.createdDate)}}</span>
                              <h4 v-if="$i18n.locale === 'uz-UZ' || $i18n.locale === 'uz-QR'"
                                  class="display-3 text-titlecolor title_text">
                                {{uzQr(item, 'titleUzQr', 'titleUzLat')}}</h4>
                              <h4 v-if="$i18n.locale === 'uz-CYR'"
                                  class="display-3 text-titlecolor title_text">
                                {{item.titleUz}}</h4>
                              <h4 v-if="$i18n.locale === 'ru-RU'"
                                  class="display-3 text-titlecolor title_text">
                                {{item.tilteRu}}</h4>
                              <h4 v-if="$i18n.locale === 'en-US'"
                                  class="display-3 text-titlecolor title_text">
                                {{item.titleEn}}</h4>
                            </blockquote>
                          </router-link>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              <div style="display: flex; justify-content: center; align-items: center; margin-top: 12px">
                <el-pagination
                    align="center"
                    background
                    layout="prev, pager, next"
                    @current-change="onPageChange"
                    :current-page.sync="paging.current"
                    :page-size="paging.size"
                    :total="paging.total">
                </el-pagination>
                <span style="margin-left: 16px">{{$t('app.bosh_stat')}} {{ paging.total }}</span>
              </div>
            </div>
        </el-col>
    </el-row>
</template>

<script>
    import moment from "moment";
    export default {
        name: "MainPagePanel4",
      data() {
        return {
          selectedDate: "",
          days: [],
          activeName: "korrupsiyaga_qkurash",
          pagination: {
            default: 1
          },
          categories: [],
          categoryId: 11,
          news: [],
          lastNews: [],
          currentNews: null,
          paging: {
            sort: null,
            page: 0,
            size: 12,
            total: 0,
            current: 1
          }
        };
      },
      computed: {
        dates() {
          return this.days.map(day => day.date);
        },
        attributes() {
          return this.dates.map(date => ({
            highlight: true,
            dates: date,
          }));
        },
      },
      methods: {
        handleClick(tab, event) {
          this.activeName = tab.name;
          this.paging.current = 1;
          switch (tab.name) {
            case "korrupsiyaga_qkurash":
              if (this.categoryId !== 11) {
                this.categoryId = 11;
                this.paging.page = 0;
                this.paging.current = 1;
                this.loadNewsByCategory();
                break;
              }
          }
        },
        loadNewsByCategory() {
          this.news = [];
          this.$axios
              .get(
                  `https://www.prokuratura.uz/api/news/page/category-and-date/${this.categoryId}?page=${this.paging.page}&date=${this.selectedDate}`
                  // `http://172.18.45.189:8080/api/news/page/category-and-date/${this.categoryId}?page=${this.paging.page}&date=${this.selectedDate}`
              )
              .then(response => {
                this.news = response.data.content;
                this.paging.total = response.data.totalElements;
              });
        },
        parseDate(dateTime) {
          return moment(dateTime).format("DD.MM.YYYY");
        },
        uzQr(item, qrKey, fallbackKey) {
          return (item && item[qrKey]) || (item && item[fallbackKey]) || "";
        },
        onPageChange(current) {
          this.paging.current = current;
          this.paging.page = current - 1;
          this.loadNewsByCategory();
        }
      },
      created() {
        this.days.push(new Date());
        this.loadNewsByCategory();
        this.$axios
            .get(`https://www.prokuratura.uz/api/news/last-news?size=8`)
            .then(response => {
              this.lastNews = response.data.content;
              this.currentNews = this.lastNews[0];
            });
      },
        mounted() {
            this.selectedComponent = 'MainPagePanel4';
        }
    };
</script>

<style scoped>
    @import url(../../../assets/css/custom.scss);
    .category_button{
      padding: 10px;
      margin: 5px;
    }
    .bg-defaultnew {
      background: #fff;
      cursor: pointer;
    }

    .press_news_status {
      color: #fff;
      position: absolute;
      font-size: 12px;
      text-transform: uppercase;
      padding: 4px 8px;
      right: 10px;
      top: 10px;
      border-radius: 0px;
      background: rgba(57, 72, 105, 0.85);
    }

    .press_fastnews_status {
      color: #fff;
      position: absolute;
      font-size: 12px;
      text-transform: uppercase;
      padding: 4px 8px;
      right: 10px;
      top: 10px;
      border-radius: 0px;
      background: rgba(207, 52, 118, 0.85);
    }

    .tab_div_top {
      min-height: 400px;
      margin-top: 15px;
    }

    /deep/ .card .card-blockquote {
      padding: 1rem;
      position: relative;
      padding-top: 5px;
      height: 88px;
    }

    /deep/ .badge {
      display: inline-block;
      padding: 0.35rem 0.375rem;
      font-size: 76%;
      font-weight: 600;
      margin-left: -6px;
      line-height: 1;
      text-align: center;
      position: absolute;
      white-space: nowrap;
      top: -32px;
      vertical-align: baseline;
      border-radius: 0rem;
    }

    /deep/ .badge-primary {
      color: #394869;
      background-color: #f0f4f9;
    }

    /deep/ .card .card-blockquote {
      padding: 1rem;
      position: relative;
      padding-top: 5px;
      height: 38px;
    }

    /deep/ .card-img-top {
      height: 240px;
      object-fit: cover;
      border-radius: 0px;
    }

    .textnew-title_color {
      color: #394869;
    }
    hr {
      border: none;
      border-left: 1px solid #00b0f0;
      height: 14px;
      margin: 4px 5px;
      width: 1px;
    }
</style>
